import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

// Redux
import { GetContactType, saveContactType } from "./index";

// Api's
import { contactTypeApi } from "../../api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getContactTypeSaga(action: GetContactType) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(contactTypeApi.getDomain, action.payload.request);

		if (response.data.result) {
			yield put(saveContactType(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveContactType(null, true, resultError.messagesDataError));
		}
	}
}
